import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {I18nModule} from '@spartacus/core';
import {TermsAndConditionsModule} from '../checkout-terms-conditions/terms-and-conditions.module';
import {ProvidedByModule} from '../provided-by/provided-by.module';
import {BundleProvidedByComponent} from './bundle-provided-by.component';
import {EntryGroupModule} from './entry-group/entry-group.module';

@NgModule({
  declarations: [BundleProvidedByComponent],
  imports: [
    CommonModule,
    I18nModule,
    ProvidedByModule,
    TermsAndConditionsModule,
    EntryGroupModule,
  ],
  exports: [BundleProvidedByComponent],
})
export class BundleProvidedByModule {}
